import { useControl } from "../hooks";
import { Checkbox, type CheckboxProps } from "./Checkbox";

export type FormCheckboxProps = Omit<CheckboxProps, "value" | "error">;

export const FormCheckbox = ({ onChange, ...props }: FormCheckboxProps) => {
	const { error, field } = useControl({ name: props.name });
	return (
		<Checkbox
			{...props}
			{...field}
			onChange={(e) => {
				field.onChange(e);
				onChange?.(e);
			}}
			error={error}
		/>
	);
};
